module.exports = __webpack_public_path__ + "static/img/advertising12.ea81d193.jpg";